/* Custom Modal Component - React 19 Compatible */
import React from 'react';
import PropTypes from 'prop-types';

import Title from "./Title.jsx";
import Subtitle from "./Subtitle.jsx";
import LoadingScreen from "./LoadingScreen.jsx";

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000
};

const modalDialogStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '20px',
  maxWidth: '90vw',
  maxHeight: '90vh',
  overflow: 'auto',
  position: 'relative',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
};

const closeButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '15px',
  background: 'none',
  border: 'none',
  fontSize: '20px',
  cursor: 'pointer',
  color: '#666',
  fontWeight: 'bold'
};

const CustomModal = (props) => {
  // Handle click on overlay to close modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      props.onClose();
    }
  };

  // Handle escape key
  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        props.onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [props.onClose]);

  // Set the body according to whether to show a loading screen
  const body = props.isLoading ? <LoadingScreen /> : (
    <span className="container">
      {props.children}
    </span>
  );

  // Return the specified body, wrapped by the modal
  return (
    <div style={modalOverlayStyle} onClick={handleOverlayClick}>
      <div style={modalDialogStyle}>
        <button 
          style={closeButtonStyle}
          onClick={props.onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        
        <div className="container">
          {
            props.title && props.title !== "" &&
            <div className="popup-title">
              <Title>{props.title}</Title>
            </div>
          }
          {
            props.subtitle && props.subtitle !== "" &&
            <div className="popup-subtitle">
              <Subtitle>{props.subtitle}</Subtitle>
            </div>
          }
          <hr />

          {body}
        </div>
      </div>
    </div>
  );
};

CustomModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  isLoading: PropTypes.bool,
  children: PropTypes.node
};

CustomModal.defaultProps = {
  title: "",
  subtitle: "",
  isLoading: false
};

export default CustomModal;